import React from "react";
import { FaChartLine, FaChartArea, FaSlidersH } from "react-icons/fa";

function Futures() {
  return (
    <>
      <div className="choose-us-style-two default-padding bg-gray blurry-shape-left-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-1">
              <div className="site-heading">
                <h4 className="sub-title">Design Startup</h4>
                <h2 className="title split-text-right split-text-in-right">
                  How Crypto Derivatives Exchange Functions?
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row align-center">
            <div className="col-lg-6">
              <div className="choose-us-two-thumb d-flex align-items-center justify-content-center">
                <FaChartLine size={200} color="#0a1f44" />
              </div>
            </div>
            <div className="col-lg-6 pl-md-15 pl-xs-10">
              <div className="choose-us-two-info">
                <p>
                  Crypto derivatives exchanges provide leveraged trades,
                  enabling users to amplify their potential gains or losses by
                  borrowing funds to trade larger positions than they could with
                  their own capital. These platforms are popular for hedging,
                  speculation, and risk management.
                </p>
                <ul className="list-style-four">
                  <li>
                    <div className="icon">
                      <FaChartArea size={40} />
                    </div>
                    <div className="info">
                      <h4>Futurescs</h4>
                      <p>
                        Contracts to buy or sell a cryptocurrency at a specific
                        price on a future date.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <FaSlidersH size={40} />
                    </div>
                    <div className="info">
                      <h4>Options</h4>
                      <p>
                        Contracts that give traders the right, but not the
                        obligation, to buy or sell at a predetermined price
                        before a certain date.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Futures;
